"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _arkReact = require("@dateam/ark-react");
var _FormContext = _interopRequireDefault(require("./FormContext"));
var _switch = _interopRequireDefault(require("../switch"));
const FormSwitch = _ref => {
  let {
    value,
    className,
    readOnly,
    required,
    children,
    onChange
  } = _ref;
  const {
    controlId,
    required: isRequired,
    onRequiredChange
  } = _react.default.useContext(_FormContext.default);
  const [internalValue, setInternalValue] = (0, _arkReact.useInternalValueManager)(value);
  const [isInvalid, setIsInvalid] = _react.default.useState(false);
  _react.default.useEffect(() => onRequiredChange?.(required ?? false), [required, onRequiredChange]);
  const checkValidation = _react.default.useCallback(value => {
    let isInvalid = false;
    if (isRequired && (value == null || value.length === 0)) {
      isInvalid = true;
    }
    return isInvalid === false;
  }, [isRequired]);
  const handleSwitchChange = _react.default.useCallback(value => {
    const isValid = checkValidation(value);
    setInternalValue(value);
    setIsInvalid(isValid === false);
    onChange?.(value);
  }, [onChange, setInternalValue, setIsInvalid]);
  return /*#__PURE__*/_react.default.createElement(_switch.default, {
    id: controlId,
    value: internalValue ?? '',
    readOnly: readOnly,
    onChange: handleSwitchChange
  }, children);
};
process.env.NODE_ENV !== "production" ? FormSwitch.propTypes = {
  value: _propTypes.default.string,
  className: _propTypes.default.string,
  readOnly: _propTypes.default.bool,
  required: _propTypes.default.bool,
  onChange: _propTypes.default.func
} : void 0;
FormSwitch.defaultProps = {
  value: undefined,
  className: undefined,
  readOnly: undefined,
  required: false,
  onChange: undefined
};
var _default = exports.default = FormSwitch;